<template>
	<mapbox
		@map-init="onInitialized"
		@map-load="onLoaded"
		@map-styledata="onStyleLoaded"
		@map-click="onClick"
		@map-mousemove="onMouseMove"
		@map-mouseleave="onMouseLeave"
		:access-token="accessToken"
		:map-options="{
			style:   'mapbox://styles/mapbox/outdoors-v11',
			center:  options.center,
			zoom:    options.zoom,
			maxZoom: options.maxZoom,
		}"
		:attribution-control="{
			show: false,
			position: 'bottom-right',
      	}"
		class="map"/>
</template>

<script>
  import 'Debug';
  import {countPointsDistance, countPointsTimeByDistance, normalizeRoutePathPoints, splitRoute} from '../RouteHelper';
  import clone from 'lodash/cloneDeep';
  import find from 'lodash/find';
  import Vue from 'vue';
  import Mapbox from 'mapbox-gl-vue'
  import MapboxDraw from '@mapbox/mapbox-gl-draw';
  import MapboxLanguage from '@mapbox/mapbox-gl-language';
  import '../../../vendor/mapbox-gl-styles';
  import RouteMapPopup from './RouteMapPopup.vue'
  import RouteMapMarker from './RouteMapMarker';
  import {toHumanDistance, toMinutes} from "../../Helpers";
  import {SimpleSelect, DirectSelect} from '../MapboxCustomDrawModes';
  import ProvidersColors from '../RoutePathProvidersColors';
  import DrawModeStyles from '../RouteMapDrawStyles';

  const LOGGER_NAME = 'App.Tour.Route.RouteMap';

  const MAP_DEFAULT_ZOOM = 1.5;

  const MAP_MAX_ZOOM = 22;

  const BOUNDS_PADDING = 50;

  const PATHS_SOURCE_NAME = 'paths';

  const PATHS_LAYER = 'paths';

  const PATHS_TEXT_LAYER = 'paths-text';

  const LOADING_PATHS_LAYER = 'loading-paths';

  export default {
    components: {
      Mapbox
    },
    props: {
      app: Object,
      sectorId: Number,
      objects: Array,
      routeObjects: Array,
      updateObjectPosition: Function,
      routePaths: Object,
      getRoutePathKey: Function,
      getRoutePathInEditMode: Function,
      openRoutePath: Function,
      closeRoutePath: Function,
      updateRoutePath: Function,
      exitRoutePathEditMode: Function,
      playerState: Object
    },
    watch: {
      objects: {
        handler: function () {
          if (!this.isReady()) {
            return false;
          }

          this.logger('watch objects.handler');
          this
			  .putMarkersOnMap()
			  .fitBoundsByMarkers();
        },
        immediate: true,
      },
      routeObjects: {
        handler: function () {
          if (!this.isReady()) {
            return false;
          }
          this
			.putMarkersOnMap();
			// .fitBoundsByMarkers();
          this.putPathsOnMap();
        },
        immediate: true,
      },
      routePaths: {
        handler: function () {
          if (!this.isReady()) {
            return false;
          }
          this.putPathsOnMap();
        },
        immediate: true,
      },
      sectorId: {
        handler: function () {
          if (!this.isReady()) {
            return false;
          }
          // this.$forceUpdate();
        },
        immediate: true,
      },
    },
    data() {
      return {
        accessToken: window.keys.mapbox || '',
        options: {
          zoom: MAP_DEFAULT_ZOOM,
          maxZoom: MAP_MAX_ZOOM,
          center: [-12.49, 26.73]
        }
      }
    },
    computed: {},
    created: function () {
      this.log = debug(LOGGER_NAME);
      this.onStyleLoadedFunction = null;
      this.map = null;
      this.markers = [];
      this.paths = [];
      this.loadingPathsAnimation = null;
      this.hoveredStateId = null;
      this.editModeFeatureId = null;
    },
    updated: function () {
      this.logger('Updated');
    },
    methods: {
      logger() {
        return this.log(...arguments);
      },
      isReady() {
        return typeof this.map !== 'undefined' && this.map._loaded === true
      },
      /**
       * Called when map is initialized
       */
      onInitialized(map) {
        this.logger('Initialized');
        this.map = map;
        this.createTooltip();

        this.addLanguageControl();
        this.addStylesControl();
        this.addDrawControl();
      },
	  addLanguageControl() {
        // Auto language plugin
        this.map.addControl(new MapboxLanguage({
          // getLanguageField: Lang.getLocale,
          defaultLanguage: this.app.Language.getLocale()
        }));
	  },
	  addStylesControl() {
		// Style switcher
		this.map.addControl(new StylesControl(
		  [
			{
				name: 'Схема',
				url: 'mapbox://styles/mapbox/outdoors-v11',
				isDefault: true
			}, {
				name: 'Спутник',
				url: 'mapbox://styles/mapbox/satellite-streets-v11'
			}
		  ]
		), 'top-right');
	  },
	  addDrawControl() {
        // Add MapboxDraw
        this.draw = new MapboxDraw({
          displayControlsDefault: false,
          modes: {
            ...MapboxDraw.modes,
            simple_select: SimpleSelect,
            direct_select: DirectSelect
          },
          clickBuffer: 10,
          touchBuffer: 30,
          styles: DrawModeStyles
        });
        this.map.addControl(this.draw);
        this.subscribeToDrawEvents();
	  },
      /**
       * Called when map is loaded
       */
      onLoaded(map) {
        this.logger('Loaded');
        this.subscribeToEvents();
      },
      onStyleLoaded(map) {
        // this.logger('Style loaded');
        clearTimeout(this.onStyleLoadedFunction);
        this.onStyleLoadedFunction = setTimeout(() => {
          this.logger('onStyleLoaded');
          this.putMarkersOnMap();
          this.putPathsOnMap();
          // this.fitBoundsByMarkers();
		}, 1000);
	  },
      /**
       * Catches click events
       */
      onClick(map, e) {
		/**
        let features = map.queryRenderedFeatures(e.point);

        this.logger('Clicked on map with features:', features);

        if (!features.length) {
          return;
        } */

        // var feature = features[0];

        //const title = e.features[0].properties.title;
        //console.log(title);
      },
      onMouseMove(map, e) {
        // this.logger('On mouse move:', map, e);
      },
      onMouseLeave(map, e) {
        this.logger('On mouse leave:', map, e);
      },
      subscribeToEvents() {

        // Mouse interactions on PATHS_LAYER
		this.map.on('mousemove', PATHS_LAYER, (e) => {
		  this.onPathsLayerMouseMove(e);
		}).on('mouseleave', PATHS_LAYER, (e) => {
		  this.onPathsLayerMouseLeave(e);
		}).on('click', PATHS_LAYER, (e) => {
		  this.onPathsLayerClick(e);
		});

        // Mouse interactions on PATHS_TEXT_LAYER
		/*
		this.map.on('mousemove', PATHS_TEXT_LAYER, (e) => {
		  this.onPathsLayerMouseMove(e);
		}).on('mouseleave', PATHS_TEXT_LAYER, (e) => {
		  this.onPathsLayerMouseLeave(e);
		}).on('click', PATHS_TEXT_LAYER, (e) => {
		  this.onPathsLayerClick(e);
		}); */

	  },
      onPathsLayerClick(e) {

        // Filter only paths layer
        let features = this.map.queryRenderedFeatures(e.point, {
          layers: [PATHS_LAYER /*, PATHS_TEXT_LAYER */]
        });

        if (features.length > 0) {
          console.log(features[0].properties.key);
          this.openRoutePath(features[0].properties.key);
        }

      },
      onPathsLayerMouseMove(e) {

        // Filter only paths layer
        let features = this.map.queryRenderedFeatures(e.point, {
          layers: [PATHS_LAYER /*, PATHS_TEXT_LAYER */]
        });

        // Change cursor for hovered path
        this.map.getCanvas().style.cursor = (features.length) ? 'pointer' : '';

        if (features.length > 0) {

          if (this.hoveredStateId) {
            // set the hover attribute to false with feature state
            this.map.setFeatureState({
              source: PATHS_SOURCE_NAME,
              id:     this.hoveredStateId
            }, {
              hover: false
            });
          }

          this.hoveredStateId = features[0].id;

          // set the hover attribute to true with feature state
          this.map.setFeatureState({
            source: PATHS_SOURCE_NAME,
            id: this.hoveredStateId
          }, {
            hover: true
          });

        }

      },
      onPathsLayerMouseLeave(e) {

        if (this.hoveredStateId) {
          // set the hover attribute to false with feature state
          this.map.setFeatureState({
            source: PATHS_SOURCE_NAME,
            id:     this.hoveredStateId
          }, {
            hover: false
          });
        }

      },
      createTooltip() {
        this.tooltip = new mapboxgl.Popup({
          closeButton: false
        });
      },
      /**
       * Puts markers on map
       */
      putMarkersOnMap() {

        this.logger('Putting markers on the map');
        this.removeMarkers();

        this.objects.forEach(object => {

          let marker = new mapboxgl.Marker({
            draggable: false,
            element: this.createMarkerIcon(object)
          }).setLngLat(object.position_point);
          marker.properties = object;
          marker.isInRoute = this.isMarkerInRoute(object.id);
          marker.addTo(this.map);

          new RouteMapMarker({
            propsData: {
              app:          this.app,
              object:       object,
              routeObjects: this.routeObjects
            },
          }).$mount(`#marker${object.id}`);

          let markerElement = marker.getElement();

          if (typeof object.audio_preview === 'string') {
            markerElement.classList.add('mini-player');
            markerElement.classList.add('is-disabled');
            markerElement.setAttribute('data-src', object.audio_preview);
		  }

          markerElement.addEventListener('mouseenter', () => {
            markerElement.style.zIndex = '1000';
            this.map.getCanvas().style.cursor = 'pointer';
          });

          markerElement.addEventListener('mouseleave', () => {
            markerElement.style.zIndex = 'auto';
            this.map.getCanvas().style.cursor = '';
          });

          marker.getElement().addEventListener('click', (event) => {
            setTimeout(() => {
              this.onMarkerClicked(marker);
            }, 10);
            // event.stopPropagation();
          });

          marker.getElement().addEventListener('dblclick', (event) => {
            setTimeout(() => {
              this.onMarkerDblClicked(marker);
            }, 10);
            event.stopPropagation();
            event.preventDefault();
          });

          this.markers.push(marker);

        });

        this.refreshTooltip();
        return this;

      },
      isMarkerInRoute(id) {
        return this
          .routeObjects
          .filter(routeObject => {
            return routeObject.id === id
          })
          .length === 1;
      },
	  /**
	   * Creates marker's popup on click
	   */
      onMarkerClicked(marker) {

        if (marker.isDraggable()) {
          return false;
		}

        let object = marker.properties;

        marker.popup = new mapboxgl.Popup({
          offset: 15
        })
          .setLngLat(object.position_point)
          .setHTML(this.createMarkerPopup(object))
          .addTo(this.map);

        new RouteMapPopup({
          propsData: {
            app:          this.app,
            object:       object,
			routeObjects: this.routeObjects
		  },
        })
		  .$mount(`#markerPopup${object.id}`)
          .$on('toggleRouteObject', (id) => {
            this.$emit('toggleRouteObject', id);
          });

        this.refreshTooltip();

      },
	  /**
	   * Makes marker draggable
	   */
      onMarkerDblClicked(marker) {
        if (typeof marker.popup !== 'undefined') {
          marker.popup.remove();
		}
        marker.setDraggable(!marker.isDraggable());

        if (marker.isDraggable()) {
          marker.getElement().classList.add('is-draggable');
		} else {
          marker.getElement().classList.remove('is-draggable');
          this.onMarkerDragFinish(marker);
		}

      },
	  /**
	   * When marker's drag finished
	   */
      onMarkerDragFinish(marker) {
        if (typeof marker.popup !== 'undefined') {
          marker.popup.remove();
		}
        this.updateObjectPosition(marker.properties.id, {
          lng: marker.getLngLat().lng,
          lat: marker.getLngLat().lat
        });
      },
      /**
       * Returns true if markers are available
       */
      isMarkersAvailable() {
        return (typeof this.markers !== 'undefined' && this.markers.length > 0)
      },
      /**
       * Removes markers from map
       */
      removeMarkers() {
        if (!this.isMarkersAvailable())
          return false;

        this.markers.forEach(marker => {
          marker.remove();
        });
        this.markers = [];
      },
      createMarkerIcon(object) {
        return $(`<span class='map-marker'><span id='marker${object.id}'></span></span>`).get(0);
      },
      createMarkerPopup(object) {
        return `<div id='markerPopup${object.id}'></div>`;
      },
      getRoutePath(key) {
        return this.routePaths[key];
      },
      /**
       * Returns true if paths are available
       */
      isPathsAvailable() {
        return (typeof this.paths !== 'undefined' && this.paths.length > 0)
      },
	  isPathsLayersExist() {
        return (
          typeof this.map.getLayer(PATHS_LAYER) !== 'undefined'
          && typeof this.map.getLayer(LOADING_PATHS_LAYER) !== 'undefined'
		);
	  },
	  /**
	   * Returns paths source or create new one
	   */
	  getOrCreatePathsSource() {
	    let source = this.map.getSource(PATHS_SOURCE_NAME);
	    if (!source) {

	      // Create source
          this.map.addSource(PATHS_SOURCE_NAME, {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: []
            }
          });

          source = this.map.getSource(PATHS_SOURCE_NAME);

          // Create layer for LOADED paths
          this.map.addLayer({
			id:     PATHS_LAYER,
			type:   'line',
			source: PATHS_SOURCE_NAME,
			filter: [
              'all',
			  ['==', ['get', 'isLoading'], false],
              ['==', ['get', 'isInEditMode'], false],
			  ['==', ['get', 'isText'], false]
			],
            layout: {
			  'line-join': 'round',
			  'line-cap': 'round'
			},
            paint: {
			  'line-color': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                'red',
                ['get', 'color']
              ],
			  'line-width': 4,
			  'line-opacity': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                1,
                0.7
              ]
			}
		  });

          // Create TEXT layer for LOADED paths
		  /*
          this.map.addLayer({
			id:     PATHS_TEXT_LAYER,
			type:   'symbol',
			source: PATHS_SOURCE_NAME,
            filter: [
              'all',
              ['==', ['get', 'isLoading'], false],
              ['==', ['get', 'isInEditMode'], false],
              ['==', ['get', 'isText'], true]
            ],
            layout: {
              'text-field': [
                'concat',
				['get','distance'],
				'\n~',
				['get','time']
			  ],
              'text-font': ['Open Sans Bold','Arial Unicode MS Bold'],
              'text-size': 10,
			  'text-line-height': 1,
              'text-letter-spacing': 0.05,
              'text-justify': 'auto',
              'text-offset': [0, 0]
			},
            paint: {
              'text-color': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                'red',
                ['get', 'color']
              ],
              'text-halo-color': '#fff',
              'text-halo-width': 2
			}
		  });
		   */

          // Create layer for LOADING(!) paths
          this.map.addLayer({
			id:     LOADING_PATHS_LAYER,
			type:   'line',
			source: PATHS_SOURCE_NAME,
            filter: [
              '==',
              ['==', ['get', 'isLoading'], true],
              ['==', ['get', 'isText'], false]
            ],
            layout: {
			  'line-join': 'round',
			  // 'line-cap':  'round'
			},
            paint: {
			  'line-color':     ['get', 'color'],
			  'line-width':     4,
			  'line-opacity':   0.7,
			  'line-dasharray': [0.5, 2]
			}
		  });

		}

	    return source;
	  },
      /**
       * Removes markers from map
       */
      removePaths() {
        /*
        if (!this.isPathsAvailable())
          return false;

        this.paths.forEach(path => {
          this.map.removeLayer(path);
          this.map.removeSource(path);
        });

        this.paths = [];
         */
      },
      /**
       * Puts paths on map
       */
      putPathsOnMap() {

        let loadingPathsAnimationNeed = false,
		  	editModeNeed = false;

        let data = {
          type: 'FeatureCollection',
          features: []
        };

		this.removePaths();
        this.logger('Put paths on map');

        for(let i = 0; i < this.routeObjects.length; i++) {
          // Create path
          if (i > 0 && (i - 1) <= this.routeObjects.length) {

            let currentRouteObject = this.routeObjects[i],
              	previousRouteObject = this.routeObjects[i-1],
              	key = this.getRoutePathKey(previousRouteObject, currentRouteObject),
			  	path = this.getRoutePath(key);

            // this.logger(`Put path ${key} on map:`, path);

			if (path.isLoading === true) {
              loadingPathsAnimationNeed = true;
			}

			if (path.isInEditMode === true) {
               editModeNeed = true;
			}

            data.features.push(
              this.createPathFeature(path)
			);

			/*
            data.features.push(
              this.createTextPathFeature(path)
			);
			*/

          }
        }

        let source = this.getOrCreatePathsSource();
        source.setData(data);

        if (loadingPathsAnimationNeed === true) {
          this.startLoadingPathsAnimation();
		} else {
          this.stopLoadingPathsAnimation();
		}

        if (editModeNeed === true) {
          this.enterEditMode();
		} else {
          this.exitEditMode();
		}

      },
	  createPathFeature(path) {

		return {
          id: 	path.id || 0,
		  type: 'Feature',
		  properties: {
            id: 	      path.id || 0,
			key:          path.key,
			color:        ProvidersColors[path.provider] || ProvidersColors.default,
            isText:       false,
			isLoading:    path.isLoading,
			isInEditMode: path.isInEditMode,
		  },
		  geometry: {
			type: 'LineString',
			coordinates: path.points
		  }
		};

	  },
	  createTextPathFeature(path) {

        let fullRoute = splitRoute(clone(path.points), 1);

		return {
          id: 	       path.id || 0,
		  type:        'Feature',
		  properties:  {
            id: 	      path.id || 0,
            key:          path.key,
		    distance:     toHumanDistance(path.distance),
		    time:         `${toMinutes(path.time)} мин.`,
			color:        ProvidersColors[path.provider] || ProvidersColors.default,
            isText:       true,
			isLoading:    path.isLoading,
            isInEditMode: path.isInEditMode,
		  },
		  geometry: {
			type: 'Point',
			coordinates: fullRoute[ Math.floor((fullRoute.length - 1) / 2) ]
		  }
		};

	  },
      startLoadingPathsAnimation() {
        let dashLength = 3;
        let gapLength = 1.5;

        // We divide the animation up into 40 steps to make careful use of the finite space in
        // LineAtlas
        let steps = 40;
        // A # of steps proportional to the dashLength are devoted to manipulating the dash
        let dashSteps = steps * dashLength / (gapLength + dashLength);
        // A # of steps proportional to the gapLength are devoted to manipulating the gap
        let gapSteps = steps - dashSteps;

        // The current step #
        let step = 40;

        this.stopLoadingPathsAnimation();
        this.loadingPathsAnimation = setInterval(() => {
          step = step - 1;
          if (step === 0) step = 40;

          let t, a, b, c, d;
          if (step < dashSteps) {
            t = step / dashSteps;
            a = (1 - t) * dashLength;
            b = gapLength;
            c = t * dashLength;
            d = 0;
          } else {
            t = (step - dashSteps) / (gapSteps);
            a = 0;
            b = (1 - t) * gapLength;
            c = dashLength;
            d = t * gapLength;
          }

          this.map.setPaintProperty(LOADING_PATHS_LAYER, 'line-dasharray', [a, b, c, d]);
        }, 20);

	  },
      stopLoadingPathsAnimation() {
        clearInterval(this.loadingPathsAnimation);
	  },
	  enterEditMode() {

        if (this.editModeFeatureId !== null) {
          return this;
		}

        let routePathInEditMode = this.getRoutePathInEditMode();

        if (routePathInEditMode !== null) {

          let sourceFeature = find(this.map.querySourceFeatures(PATHS_SOURCE_NAME, {
            sourceLayer: PATHS_LAYER,
            filter: [
              'all',
			  ['in', 'key', routePathInEditMode.key],
			  ['==', '$type', 'LineString'],
			]
          }), (feature) => {
            return feature.geometry.type === 'LineString';
		  });

          this.logger('Enter edit mode:', sourceFeature);

          if (typeof sourceFeature !== 'undefined') {

            let feature = clone(sourceFeature);

            // Fix coordinates
            feature.geometry.coordinates = normalizeRoutePathPoints(
              routePathInEditMode,
			  feature.geometry.coordinates
			);

            // Add feature to draw tool
            let featuresIds = this.draw.add({
              type: 'FeatureCollection',
              features: [
                feature
              ]
            });

            // Select feature for edit
            this.draw.changeMode('direct_select', {
              featureId: featuresIds[0]
			});

            // Save last edit feature id
            this.editModeFeatureId = featuresIds[0];

          }

        }

	  },
	  exitEditMode() {

        let routePathInEditMode = this.getRoutePathInEditMode();
        if (routePathInEditMode !== null) {
          this.exitRoutePathEditMode(routePathInEditMode.key);
		}

        this.editModeFeatureId = null;
        this.draw.set({
          type: 'FeatureCollection',
          features: []
        });

      },
      subscribeToDrawEvents() {

        this.map.on('draw.update', (e) => {
          this.onDrawUpdate(e);
        }).on('draw.selectionchange', (e) => {
          this.onDrawSelectionChange(e);
        }).on('draw.modechange', (e) => {
          this.onDrawModeChange(e);
        });

      },
      onDrawModeChange(e) {
        if (e.mode === 'simple_select') {
          this.exitEditMode();
		}
	  },
	  onDrawSelectionChange(e) {
        if (typeof e.features[0] !== 'undefined') {
          this.onDrawFeatureUpdate(e.features[0]);
		}
	  },
	  onDrawUpdate(e) {
        if (typeof e.action === 'string' && e.action === 'change_coordinates') {
          this.onDrawFeatureUpdate(e.features[0]);
		}
	  },
	  onDrawFeatureUpdate(feature) {

        // console.log('Draw update', JSON.stringify(feature.geometry.coordinates));

        let routePathInEditMode = this.getRoutePathInEditMode();

        if (typeof feature !== 'undefined' && routePathInEditMode.key === feature.properties.key) {
          routePathInEditMode.points = normalizeRoutePathPoints(routePathInEditMode, clone(feature.geometry.coordinates));
          routePathInEditMode.distance = countPointsDistance(routePathInEditMode.points);
          routePathInEditMode.time = countPointsTimeByDistance(routePathInEditMode.distance);

          let customProviderRoute = find(routePathInEditMode.providersRoutes, ['provider', 'custom']);
          // Update custom provider route
          if (typeof customProviderRoute !== 'undefined') {
            customProviderRoute.points = routePathInEditMode.points;
            customProviderRoute.distance = routePathInEditMode.distance;
            customProviderRoute.time = routePathInEditMode.time;
		  } else {
            // Insert custom provider route
            routePathInEditMode.providersRoutes.push({
			  id: null,
			  from:     routePathInEditMode.from,
			  to:       routePathInEditMode.to,
			  provider: 'custom',
              points:   routePathInEditMode.points,
              distance: routePathInEditMode.distance,
              time:     routePathInEditMode.time,
			});

		  }
          this.updateRoutePath(routePathInEditMode.key, routePathInEditMode);
        }
	  },
      /**
       * Fits bounds by markers
       * @returns {boolean}
       */
      fitBoundsByMarkers() {

        if (!this.isMarkersAvailable())
          return false;

		this.logger('fitBoundsByMarkers()');

        let bounds = new mapboxgl.LngLatBounds(),
		  	markers = this.markers,
		  	markersInRoute = this.markers.filter(marker => {
		  	  return marker.isInRoute === true
		  	});

		(markersInRoute.length > 0 ? markersInRoute : this.markers).forEach(marker => {
          bounds.extend(marker.getLngLat());
        });

        this.map.fitBounds(
          bounds,
          {
            padding: BOUNDS_PADDING
          }
        );

      },
      refreshTooltip() {
        this.app.Events.publish('tooltip.refresh', true);
      }
    }
  }
</script>